module.exports = __webpack_public_path__ + "static/media/logo-white.ad7b1a15.svg";